/* BaseActivityViewColumnComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const _ = require("lodash");

class BaseActivityViewColumnComponent extends DefaultColumnComponent {
    constructor(activityEntity) {
        super(activityEntity);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    _normalizeCreateActivity(activityEntity) {
        let activity = {};
        _.set(activity, "activityType.activityType", "note");
        _.set(activity, "activityType.tooltip", `Network Discovery created by user ${activityEntity.createdBy}.`);
        _.set(activity, "description.description", `Network Discovery created by user ${activityEntity.createdBy}.`);
        _.set(activity, "status", "clean");
        return activity;
    }

    _normalizeUpdateActivity(activityEntity) {
        let activity = {},
            activityEntityPatch = _.find(activityEntity.patch, { path: "/status" });

        let jobId = activityEntity.getProperty("jobId");
        if (!_.isEmpty(jobId)) {
            _.set(activity, "actions.viewMore", { logId: jobId });
        }

        if (activityEntityPatch) {
            switch (activityEntityPatch.value) {
                case "RUNNING":
                    _.set(activity, "activityType.activityType", "note");
                    _.set(activity, "description.description", `Job (Network Discovery) started by (${activityEntity.createdBy}).`);
                    _.set(activity, "activityType.tooltip", "Network Discovery started");
                    _.set(activity, "status", "loading");
                    break;
                case "COMPLETE":
                    _.set(activity, "activityType.activityType", "system");
                    _.set(activity, "description.description", "Network Discovery successfully completed.");
                    _.set(activity, "activityType.tooltip", "Network Discovery completed");
                    _.set(activity, "status", "clean");
                    break;
                case "ERROR":
                    _.set(activity, "activityType.activityType", "system");
                    _.set(activity, "description.description", "Network Discovery encountered an error.");
                    _.set(activity, "activityType.tooltip", "Network Discovery failed");
                    _.set(activity, "status", "error");
                    break;
                case "CANCELED":
                    _.set(activity, "activityType.activityType", "note");
                    _.set(activity, "description.description", `Network Discovery canceled by (${activityEntity.createdBy}).`);
                    _.set(activity, "activityType.tooltip", "Network Discovery canceled");
                    _.set(activity, "status", "cancelled");
                    break;
                case "READY":
                case "DRAFT":
                    _.set(activity, "activityType.activityType", "note");
                    _.set(activity, "description.description", `Network Discovery updated by (${activityEntity.createdBy}).`);
                    _.set(activity, "activityType.tooltip", "Network Discovery updated");
                    _.set(activity, "status", "clean");
                    break;
            }
        } else {
            _.set(activity, "activityType.activityType", "note");
            _.set(activity, "description.description", `Network Discovery updated by user ${activityEntity.createdBy}.`);
            _.set(activity, "activityType.tooltip", "Network Discovery updated");
            _.set(activity, "status", "clean");
        }
        return activity;
    }

    _normalizeUnknownActivity(activityEntity) {
        let activity = {};
        _.set(activity, "activityType.activityType", "unknown");
        _.set(activity, "description.description", `Unknown activity initiated by (${activityEntity.createdBy}).`);
        _.set(activity, "activityType.tooltip", "Unknown Activity");
        _.set(activity, "status", "clean");
        return activity;
    }

    _normalizeActivity(activityEntity) {
        let activity;
        let activityType = activityEntity.getProperty("activityType");
        switch (activityType) {
            case "create":
                activity = this._normalizeCreateActivity(activityEntity);
                break;
            case "update":
                activity = this._normalizeUpdateActivity(activityEntity);
                break;
            // Hide unknown things from the user...
            // default:
            //  activity = this._normalizeUnknownActivity(activityEntity);
            // 	break;
        }
        if (activity) {
            let date =
                typeof activityEntity.createdOn !== "undefined"
                    ? new Date(activityEntity.createdOn).toLocaleDateString() + " " + new Date(activityEntity.createdOn).toLocaleTimeString()
                    : "No date time provided";
            _.set(activity, "snapshot.snapshot", date);
            _.set(activity, "id", activityEntity.id);
        }
        return activity;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = BaseActivityViewColumnComponent;
